import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { loading } from '@/decorators';

var Log = function (_super) {
  __extends(Log, _super);

  function Log() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.searchData = _this.initSearchData();
    _this.loadingStatus = false;
    _this.columns = [{
      title: _this.t('操作人'),
      dataIndex: 'create_user_name',
      filterEmpty: true
    }, {
      title: _this.t('操作类型'),
      dataIndex: 'oper_type_text',
      filterEmpty: true
    }, {
      title: _this.t('备注'),
      dataIndex: 'oper_content',
      filterEmpty: true
    }, {
      title: _this.t('时间'),
      dataIndex: 'create_time',
      filterEmpty: true
    }];
    _this.logTableData = [];
    return _this;
  }

  Log.prototype.onVisibleChange = function (value) {
    if (!value) {
      this.logTableData = [];
      return;
    }

    this.searchData = this.initSearchData();
    this.queryLogList();
  };

  Log.prototype.initSearchData = function () {
    this.logTableData = [];
    return {
      officer_no: this.record.officer_no || '',
      product_sku: this.record.product_sku || ''
    };
  };

  Log.prototype.queryLogList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, officer_no, product_sku, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = this.searchData, officer_no = _a.officer_no, product_sku = _a.product_sku;
            if (!officer_no || !product_sku) return [2];
            return [4, this.$api.product.getGpsrLog(this.searchData)];

          case 1:
            data = _b.sent().data;
            this.logTableData = data || [];
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], Log.prototype, "record", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], Log.prototype, "onVisibleChange", null);

  __decorate([loading('loadingStatus')], Log.prototype, "queryLogList", null);

  Log = __decorate([Component], Log);
  return Log;
}(Vue);

export default Log;